import {
  Home,
  Store,
  Building2,
  Building,
  UtensilsCrossed,
  CarFront,
  Gift,
} from "lucide-react";
import { ownerSection } from "../content/site";
import { Button, Container, Reveal, Eyebrow } from "./ui";

const TYPE_ICONS = [Home, Store, Building2, Building, UtensilsCrossed, CarFront];

function scrollTo(e, href) {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
}

export default function OwnerSection() {
  return (
    <section
      id="for-owners"
      className="relative overflow-hidden bg-[var(--color-bg-light-orange)] py-20 sm:py-28"
    >
      <div className="pointer-events-none absolute -top-20 -right-20 h-80 w-80 rounded-full bg-primary/10 blur-[100px]" />

      <Container className="relative">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <Eyebrow>For Parking Owners</Eyebrow>
            <h2 className="mt-5 text-3xl leading-[1.1] font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              {ownerSection.headline}
            </h2>
            <p className="mt-4 text-lg font-semibold text-navy/70">
              {ownerSection.subheadline}
            </p>
            <p className="mt-3 max-w-lg text-base text-navy/60">{ownerSection.body}</p>

            <div className="mt-8 rounded-2xl border-2 border-primary/20 bg-white p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
                  <Gift size={20} />
                </span>
                <div>
                  <p className="text-xl font-extrabold text-primary">
                    {ownerSection.highlight}
                  </p>
                  <p className="text-sm font-semibold text-navy/60">
                    {ownerSection.highlightSub}
                  </p>
                </div>
              </div>
              <p className="mt-3 text-sm font-semibold text-navy/50">
                {ownerSection.earnLine}
              </p>
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button
                href="#owner-waitlist"
                onClick={(e) => scrollTo(e, "#owner-waitlist")}
                size="lg"
              >
                {ownerSection.cta}
              </Button>
              <Button
                href="#owner-waitlist"
                onClick={(e) => scrollTo(e, "#owner-waitlist")}
                variant="outline"
                size="lg"
              >
                {ownerSection.secondaryCta}
              </Button>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="rounded-[28px] border border-navy/8 bg-white p-6 shadow-navy sm:p-8">
              <p className="mb-5 text-xs font-bold tracking-wide text-navy/40 uppercase">
                Who can list on PARKORA
              </p>
              <div className="grid grid-cols-2 gap-4">
                {ownerSection.spaceTypes.map((type, idx) => {
                  const Icon = TYPE_ICONS[idx];
                  return (
                    <div
                      key={type}
                      className="flex items-center gap-3 rounded-2xl bg-[var(--color-bg-soft)] p-4"
                    >
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy text-white">
                        <Icon size={18} />
                      </span>
                      <span className="text-sm font-bold text-navy">{type}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
